"use client";
import React from "react";

import { TabsTrigger } from "@/components/ui/tabs";
import Typography from "@/components/Typography/Typography";

import { ITabprops } from "@/interfaces/CustomTabTrigger/CustomTabTrigger";

const CustomTabTrigger = ({ children, value, className, onClick }: ITabprops) => {
  function handleClick() {
    if (onClick) {
      onClick(value);
    }
  }
  return (
    <TabsTrigger
      className={`relative cursor-pointer py-4 px-8 group ${className}`}
      value={value}
      onClick={handleClick}
    >
      <Typography
        variant="button-label"
        className="!text-colorTertiary-600 group-hover:!text-colorTertiary !font-extrabold group-data-[state=active]:!text-colorSecondary"
      >
        {children}
      </Typography>
      <hr className="absolute border-0 left-0 bottom-0 w-full h-1.5 !font-bold !bg-colorTertiary-600  group-data-[state=active]:!bg-colorSecondary" />
    </TabsTrigger>
  );
};

export default CustomTabTrigger;
